import { Link } from "react-router-dom";
import { Facebook, Instagram, Star, MapPin } from "lucide-react";
import { SOCIAL, CHECK_INFO, SLOGAN, DISCLAIMER } from "@/lib/data";
import StripeBar from "@/components/StripeBar";

export const Footer = () => (
  <footer className="bg-navy-dark text-cream" data-testid="site-footer">
    <StripeBar className="h-1.5 w-full" />
    <div className="border-b border-cream/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {["JUSTICE", "INTEGRITY", "ACCOUNTABILITY"].map((w) => (
          <span key={w} className="flex items-center gap-6">
            <span className="font-display font-extrabold uppercase tracking-widest text-lg text-cream/90">{w}</span>
            <Star className="w-3.5 h-3.5 text-crimson fill-crimson" />
          </span>
        ))}
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <div className="mb-6" data-testid="footer-brand">
          <StripeBar className="h-1.5 w-44 rounded-full overflow-hidden mb-5" />
          <p className="font-display font-black uppercase leading-[0.9] text-cream text-4xl">
            Dave<br />Graham
          </p>
          <p className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-gold mt-3">
            <Star className="w-3 h-3 fill-gold" /> For Attorney General
          </p>
        </div>
        <p className="text-cream/60 text-sm leading-relaxed max-w-xs">
          Republican candidate for Delaware Attorney General. {SLOGAN}
        </p>
      </div>

      <div>
        <h3 className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-5">Explore</h3>
        <ul className="space-y-3">
          {[
            ["Home", "/"],
            ["Meet Dave", "/meet-dave"],
            ["Priorities", "/#priorities"],
            ["News & Press", "/news"],
            ["Get Involved", "/get-involved"],
            ["Contribute", "/contribute"],
          ].map(([label, path]) => (
            <li key={label}>
              <Link
                to={path}
                data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="font-display font-bold uppercase tracking-wider text-lg text-cream/80 hover:text-gold transition-colors"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-xs tracking-[0.3em] uppercase text-gold mb-5">Campaign HQ</h3>
        <p className="flex items-start gap-2 text-cream/70 text-sm leading-relaxed mb-6">
          <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-crimson" />
          <span>
            {CHECK_INFO.payableTo}
            <br />
            {CHECK_INFO.poBox}
            <br />
            {CHECK_INFO.cityStateZip}
          </span>
        </p>
        <div className="flex items-center gap-4">
          <a
            href={SOCIAL.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            aria-label="Facebook"
            className="flex items-center gap-2 bg-cream/10 hover:bg-crimson px-4 py-2.5 rounded-full transition-colors"
          >
            <Facebook className="w-4 h-4" />
            <span className="font-display font-bold uppercase tracking-wider text-sm">Facebook</span>
          </a>
          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            aria-label="Instagram"
            className="flex items-center gap-2 bg-cream/10 hover:bg-crimson px-4 py-2.5 rounded-full transition-colors"
          >
            <Instagram className="w-4 h-4" />
            <span className="font-display font-bold uppercase tracking-wider text-sm">Instagram</span>
          </a>
        </div>
      </div>
    </div>

    <div className="border-t border-cream/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-editorial font-semibold text-sm text-cream/80" data-testid="footer-paid-for-by-disclaimer">
          {DISCLAIMER}
        </p>
        <p className="font-mono text-xs text-cream/40 uppercase tracking-wider">
          Contributions are not tax deductible.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
